import i18next from "../i18n";
import View from "./View";

class SignUpView extends View {
  _btnShowPassword = document.querySelector(".show-password");
  _countryField = document.querySelector("#country");
  _fNameField = document.querySelector("#first-name");
  _formSignUp = document.querySelector(".form-signup-account");
  _lNameField = document.querySelector("#last-name");
  _passwordDesc = document.querySelector(".password-desc");
  _passwordField = document.querySelector("#password");
  _passwordSyncInterval = null;
  _signUpBtn = document.querySelector("#sign-up");
  _setPasswordFieldType(field, targetType) {
    if (!field) {
      return;
    }

    const existingValue = field.value;
    const wasFocused = document.activeElement === field;

    field.setAttribute("type", targetType);
    field.type = targetType;

    // IOS AutoFill can keep secure masking until value is re-applied.
    if (existingValue) {
      field.value = "";
      field.value = existingValue;
    }

    if (wasFocused) {
      field.focus({ preventScroll: true });
    }
  }

  _syncPasswordUI() {
    const hasValue = this._passwordField.value !== "";
    this._btnShowPassword.style.display = hasValue ? "block" : "none";

    if (!hasValue) {
      this._setPasswordFieldType(this._passwordField, "password");
      this._btnShowPassword.textContent = i18next.t("password.show");
    }

    this.toggleSubmitButton();
  }

  // Initialize event listeners to control the submit button state
  initSubmitBtn() {
    [
      this._emailField,
      this._fNameField,
      this._lNameField,
      this._passwordField,
      this._phoneField,
    ].forEach((el) =>
      el.addEventListener("input", this.toggleSubmitButton.bind(this)),
    );

    this._countryField.addEventListener(
      "onchange",
      this.toggleSubmitButton.bind(this),
    );
  }

  renderValidation() {
    // Get the current pattern from the input's pattern attribute
    const currentPattern = new RegExp(this._phoneField.pattern, "u");

    this._signUpBtn.onclick = (event) => {
      const MIN_PASSWORD_LENGTH = 8;

      const isValid =
        this._passwordField.value.length >= MIN_PASSWORD_LENGTH &&
        this.testEmail(this._emailField.value) &&
        currentPattern.test(this._phoneField.value);

      this.validateBirthdate(event);
      this.validateEmail(event);
      this.validatePassword(event);
      this.validatePhoneNumber(event);

      if (isValid) {
        // this._formSignUp.reset();
      }
    };
  }

  // Toggle password after show button click
  togglePassword() {
    this._btnShowPassword.onclick = () => {
      const shouldReveal = this._passwordField.type === "password";
      this._setPasswordFieldType(
        this._passwordField,
        shouldReveal ? "text" : "password",
      );
      this._btnShowPassword.textContent = i18next.t(
        shouldReveal ? "password.hide" : "password.show",
      );
    };
  }

  togglePasswordBtn() {
    const AUTOFILL_SYNC_INTERVAL_MS = 400;
    const sync = this._syncPasswordUI.bind(this);
    ["input", "change", "blur", "focus"].forEach((eventName) =>
      this._passwordField.addEventListener(eventName, sync),
    );
    window.addEventListener("pageshow", sync);
    window.addEventListener("focus", sync);

    // Covers iOS AutoFill flows that do not dispatch input/change events.
    if (!this._passwordSyncInterval) {
      this._passwordSyncInterval = window.setInterval(
        sync,
        AUTOFILL_SYNC_INTERVAL_MS,
      );
    }

    sync();
  }

  // Toggle the state of the submit button based on input fields
  toggleSubmitButton() {
    const MAX_NAME_LENGTH = 50;
    const MAX_EMAIL_LENGTH = 256;
    const MAX_PHONE_LENGTH = 10;

    if (
      this._countryField.value === "" ||
      this._fNameField.value === "" ||
      this._fNameField.value.length > MAX_NAME_LENGTH ||
      this._lNameField.value === "" ||
      this._lNameField.value.length > MAX_NAME_LENGTH ||
      this._emailField.value === "" ||
      this._emailField.value.length > MAX_EMAIL_LENGTH ||
      this._passwordField.value === "" ||
      this._phoneField.value === "" ||
      this._phoneField.value.length > MAX_PHONE_LENGTH
    ) {
      // Disable submit button
      this._signUpBtn.disabled = true;
    } else {
      // Enable submit button
      this._signUpBtn.disabled = false;
    }
  }

  // Validate password
  validatePassword(event) {
    const MIN_PASSWORD_LENGTH = 8;
    if (this._passwordField.value.length < MIN_PASSWORD_LENGTH) {
      const SHAKEDURATION = 1000;
      const passwordContainer = document.querySelector(".password-container");

      // Set red color to class
      this._passwordDesc.style.color = "var(--error-color)";

      // Shake element
      passwordContainer.classList.add("shake");

      // Remove the 'shake' class after shakeDuration milliseconds
      setTimeout(() => {
        passwordContainer.classList.remove("shake");
      }, SHAKEDURATION);

      // Prevent form submission
      event.preventDefault();
    } else {
      // Set initial color to class
      this._passwordDesc.style.color = "#767676";
    }
  }
}

export default new SignUpView();
